module.exports = __webpack_public_path__ + "assets/c4a3bef2e44763f77860a1c19d49b9b4.svg";